import script from "./LinkOpenBankingAccountPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LinkOpenBankingAccountPage.vue?vue&type=script&setup=true&lang=ts"

import "./LinkOpenBankingAccountPage.vue?vue&type=style&index=0&id=1c3fe25c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c3fe25c"]])

export default __exports__